import { render, staticRenderFns } from "./CustomerInsuranceReminder.vue?vue&type=template&id=90b72206&"
import script from "./CustomerInsuranceReminder.vue?vue&type=script&lang=js&"
export * from "./CustomerInsuranceReminder.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInsuranceReminder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports